module.exports = __webpack_public_path__ + "static/media/IMG_2755.82715f2f.jpg";